export default function () {
  document.addEventListener('alpine:init', () => {
    const contentContainer = document.querySelector('main#content div.e-content');
    if (contentContainer) {
      const headings = contentContainer.querySelectorAll('h2, h3');
      if (headings) {
        headings.forEach((heading) => {
          const svgElement = createSvgElement();
          heading.appendChild(svgElement);
        });
      }
    }
  });

  /* Toggle Search */
  const searchBtn = document.getElementById('search--toggle');
  if (searchBtn) {
    searchBtn.onclick = function() {
      document.body.classList.toggle('toggled--search');
    }
  }

  const searchBtnClose = document.getElementById('search--toggle-close');
  if (searchBtnClose) {
    searchBtnClose.onclick = function() {
      document.body.classList.remove('toggled--search');
    }
  }
}

function createSvgElement(): SVGElement {
  const svgNamespace = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNamespace, "svg");
  svg.setAttribute("xmlns", svgNamespace);
  svg.setAttribute("width", "211.3");
  svg.setAttribute("height", "153.8");
  svg.setAttribute("viewBox", "0 0 211.3 153.8");

  const path = document.createElementNS(svgNamespace, "path");
  path.setAttribute("d", "M209.7,99.4c0,41.3-30.5,53.5-65.5,53.5c-64.2,0-143.1-38-143.1-68.9c0-32.5,85-82.4,124.5-82.4 C180.2,1.5,209.7,71.4,209.7,99.4");

  svg.appendChild(path);
  return svg;
}
